export enum AnalyticsAggregationPeriodType {
  YEAR = "Year",
  MONTH = "Month",
  DAY = "Day",
}
